import {TabContainerModel} from '@xh/hoist/cmp/tab';
import {HoistModel, managed} from '@xh/hoist/core';
import {Icon} from '@xh/hoist/icon';
import {allocations} from './allocations/Allocations';
import {distributions} from './distributions/Distributions';
import {deals} from './deals/Deals';
import {percentageIcon} from '../../../core/Icons';

export class RealEstateTabModel extends HoistModel {
    @managed tabModel = new TabContainerModel({
        route: 'default.realEstate',
        tabs: [
            {
                id: 'deals',
                icon: Icon.home(),
                content: deals
            },
            {
                id: 'distributions',
                icon: Icon.dollarSignCircle(),
                content: distributions
            },
            {
                id: 'allocations',
                icon: percentageIcon(),
                content: allocations
            }
        ]
    });
}
